<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Detalle de Nómina del periodo: {{ periodo }}
            <div>
              <BackButton :to="{ name: 'CalculoAdministrativoNomina' }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </BackButton>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol>
                <h4><strong>Trabajador:</strong> {{ trabajador }}</h4>
                <!-- <h4 class="text-danger">Más datos del trabajador</h4> -->
                <div class="d-flex flex-wrap" style="gap: 10px">
                  <div
                    v-for="(dato, i) of datos_trabajador"
                    :key="`${dato.valor}_${i}`"
                  >
                    <label
                      class="font-weight-bold h5"
                      :for="`${dato.valor}_${i}`"
                      v-if="dato.titulo"
                      >{{ dato.titulo }}:{{ " " }}</label
                    >
                    <span class="h5" :id="`${dato.valor}_${i}`">
                      {{
                        formaters(dato.formato.tipo)(
                          getDotNotation(dato.valor, p_trabajador),
                          dato.formato
                        )
                      }}</span
                    >
                  </div>
                </div>
              </CCol>
            </CRow>
            <template v-if="p_nomina">
              <CRow class="mt-4 mb-4">
                <CCol>
                  <div class="dotContainer borderRadius15 d-flex">
                    <div class="d-flex flex-1 align-items-center">
                      <h5 class="strong">
                        Si deseas realizar cambios a la información de pago del
                        trabajador, primero necesita cancelar los cálculos
                        realizados del cuadre fiscal.
                      </h5>
                    </div>
                    <CButton
                      @click="showCancelCuadre = true"
                      color="warning"
                      square
                      ><CIcon class="mr-1" name="cil-pencil" /> Cancelar<br />
                      Cuadre Fiscal</CButton
                    >
                  </div>
                </CCol>
              </CRow>
              <CRow class="mt-4 mb-4">
                <CCol sm="9">
                  <GrandTable :data="cuadre_fiscal" :columns="encuadreColumns">
                    <template
                      #monto_horas_normales="{ row, className, colStyle }"
                    >
                      <td :class="className" :style="colStyle">
                        {{
                          isNaN(row.monto_horas_normales) ||
                          row.monto_horas_normales === " "
                            ? row.monto_horas_normales || ""
                            : $formatter(row.monto_horas_normales, 1)
                        }}
                      </td>
                    </template>
                    <template
                      #monto_horas_extras="{ row, className, colStyle }"
                    >
                      <td :class="className" :style="colStyle">
                        {{
                          isNaN(row.monto_horas_extras) ||
                          row.monto_horas_extras === " "
                            ? row.monto_horas_extras || ""
                            : $formatter(row.monto_horas_extras, 1)
                        }}
                      </td>
                    </template>
                    <template
                      #subtotal_actividad_variable="{
                        row,
                        className,
                        colStyle,
                      }"
                    >
                      <td :class="className" :style="colStyle">
                        {{
                          isNaN(row.subtotal_actividad_variable) ||
                          row.subtotal_actividad_variable === " "
                            ? row.subtotal_actividad_variable || ""
                            : $formatter(row.subtotal_actividad_variable, 1)
                        }}
                      </td>
                    </template>
                    <template #subtotal="{ row, className, colStyle }">
                      <td :class="className" :style="colStyle">
                        {{
                          isNaN(row.subtotal) || row.subtotal === " "
                            ? row.subtotal || ""
                            : $formatter(row.subtotal, 1)
                        }}
                      </td>
                    </template>
                  </GrandTable>
                </CCol>
                <CCol></CCol>
              </CRow>
            </template>
            <CRow>
              <CCol v-if="!p_nomina">
                <div v-if="folio" class="dotContainer borderRadius15 d-flex">
                  <div class="d-flex flex-1 align-items-center">
                    <h5 class="strong">
                      Si deseas realizar cambios a la información de pago del
                      trabajador, primero necesita cancelar los cálculos de los
                      complementos de salario.
                    </h5>
                  </div>
                  <CButton @click="showCancelDoc = true" color="warning" square
                    ><CIcon class="mr-1" name="cil-pencil" /> Cancelar<br />
                    Cálculos Generados</CButton
                  >
                </div>
                <div v-else class="dotContainer borderRadius15 d-flex">
                  <div class="d-flex flex-1 align-items-center">
                    <h5 class="strong">
                      Realice los cambios necesarios a los documentos y pesione
                      el botón para calcular nuevamente la nómina del trabajador
                    </h5>
                  </div>
                  <CButton @click="calcularPagoDias" color="success" square
                    ><CIcon class="mr-1" name="cil-pencil" /> Calcular<br />
                    complementos de salario</CButton
                  >
                </div>
              </CCol>
            </CRow>

            <CRow class="mt-4">
              <CCol>
                <GrandTable :data="totales" :columns="totalsColumns">
                  <template
                    #monto_horas_normales="{ row, className, colStyle }"
                  >
                    <td :class="className" :style="colStyle">
                      {{
                        isNaN(row.monto_horas_normales)
                          ? ""
                          : $formatter(row.monto_horas_normales, 1)
                      }}
                    </td>
                  </template>
                  <template #monto_horas_extras="{ row, className, colStyle }">
                    <td :class="className" :style="colStyle">
                      {{
                        isNaN(row.monto_horas_extras)
                          ? ""
                          : $formatter(row.monto_horas_extras, 1)
                      }}
                    </td>
                  </template>
                  <template
                    #subtotal_actividad_variable="{ row, className, colStyle }"
                  >
                    <td :class="className" :style="colStyle">
                      {{
                        isNaN(row.subtotal_actividad_variable)
                          ? ""
                          : $formatter(row.subtotal_actividad_variable, 1)
                      }}
                    </td>
                  </template>
                  <template #subtotal="{ row, className, colStyle }">
                    <td :class="className" :style="colStyle">
                      {{
                        isNaN(row.subtotal) ? "" : $formatter(row.subtotal, 1)
                      }}
                    </td>
                  </template>
                </GrandTable>
              </CCol>
              <CCol></CCol>
            </CRow>
            <CRow class="mt-4">
              <CCol>
                <h3 class="borderBottom">Documentos Del Periodo</h3>
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`labores`)"
                  :crud="!folio"
                  :trabajador="[p_trabajador]"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`prestaciones`)"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`bonos`)"
                  :crud="!folio"
                  :trabajador="[p_trabajador]"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`bonos_aplicados`)"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`caja_de_ahorro`)"
                  :crud="!folio"
                  :trabajador="[p_trabajador]"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`caja_de_ahorro_aplicadas`)"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`prestamos`)"
                  :crud="!folio"
                  :trabajador="[p_trabajador]"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`prestamos_aplicados`)"
                />

                <template v-if="!folio">
                  <div
                    v-if="getLengthDocumentosRelacionados(`jornadas`)"
                    class="dotContainer borderRadius15 d-flex gap-2 mb-4"
                  >
                    <div class="d-flex flex-1 align-items-center">
                      <h5 class="strong">
                        Si deseas realizar cambios a las asistencias por que las
                        que se encuentran registradas no son correctas, primero
                        necesitas cancelar las jornadas que fueron generadas.
                      </h5>
                    </div>
                    <CButton
                      @click="showCancelJornada = true"
                      color="warning"
                      square
                      ><CIcon class="mr-1" name="cil-pencil" /> Cancelar<br />
                      jornadas generadas</CButton
                    >
                  </div>
                  <div
                    v-else
                    class="dotContainer borderRadius15 d-flex gap-2 mb-4"
                  >
                    <div class="d-flex flex-1 align-items-center">
                      <h5 class="strong">
                        Realice los cambios necesarios a las asistencias y
                        presione el botón para calucular nuavamente las jornadas
                        del trabajador.
                      </h5>
                    </div>
                    <CButton @click="calcularJornadas" color="success" square>
                      <CIcon class="mr-1" name="cil-pencil" /> Calcular jornadas
                    </CButton>
                  </div>
                </template>
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`jornadas`)"
                />
                <SimpleTableCalculoAdministrativo
                  :hasTheCredential="hasTheCredential"
                  v-if="!isLoadingPage"
                  @getData="getData"
                  nomina
                  :row="getDocumentosRelacionados(`asistencias`)"
                  :crud="!getLengthDocumentosRelacionados(`jornadas`)"
                  :trabajador="[p_trabajador]"
                />
              </CCol>
            </CRow>
            <CModal
              title="Nomina"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >
              {{ error }}
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="showCancelDoc"
    >
      <template #header>
        <h5 class="modal-title">Cancelar calculos</h5>
        <CButtonClose @click="showCancelDoc = false" class="text-white" />
      </template>
      ¿Esta seguro que quiere cancelarlos?
      <template #footer>
        <CButton @click="showCancelDoc = false" color="danger"
          >Cancelar</CButton
        >
        <CButton @click="cancelarDoc()" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="showCancelCuadre"
    >
      <template #header>
        <h5 class="modal-title">Cancelar cuadre</h5>
        <CButtonClose @click="showCancelCuadre = false" class="text-white" />
      </template>
      ¿Esta seguro que quiere cancelarlos?
      <template #footer>
        <CButton @click="showCancelCuadre = false" color="danger"
          >Cancelar</CButton
        >
        <CButton @click="cancelarCuadre()" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="showCancelJornada"
    >
      <template #header>
        <h5 class="modal-title">Cancelar jornadas</h5>
        <CButtonClose @click="showCancelJornada = false" class="text-white" />
      </template>
      ¿Esta seguro que quiere cancelarlos?
      <template #footer>
        <CButton @click="showCancelJornada = false" color="danger"
          >Cancelar</CButton
        >
        <CButton @click="cancelarJornadas()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :closeOnBackdrop="false"
      size="sm"
      :title="loadingModal || ''"
      :centered="true"
      color="info"
      :show.sync="_loadingModal"
    >
      <template #footer>
        <strong></strong>
      </template>
      <div class="w-100 d-flex justify-content-center">
        <div class="sk-flow align-items-center">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </CModal>
  </div>
</template>

<script>
import moment from "moment";
import SimpleTableCalculoAdministrativo from "./SimpleTableCalculoAdministrativo.vue";
import GrandTable from "./GrandTable.vue";
import "vue-select/dist/vue-select.css";
import DocsTranslationMixin from "@/mixins/DocsTranslationMixin";
import DotNotationMixin from "@/mixins/DotNotationMixin";
import CredentialMixin from "@/mixins/CredentialMixin";

export default {
  name: "VerCalculoAdministrativoNomina",
  mixins: [DocsTranslationMixin, CredentialMixin, DotNotationMixin],
  components: {
    SimpleTableCalculoAdministrativo,
    GrandTable,
  },
  data() {
    return {
      loadingModal: "",

      folio: this.$route.params?.id,

      p_periodo_inicial: this.$route.params?.periodo_inicial,
      p_periodo_final: this.$route.params?.periodo_final,
      p_empresa_id: this.$route.params?.empresa_id,
      p_trabajador_id: this.$route.params?.trabajador_id,

      p_trabajador: { id: this.$route.params?.trabajador_id },
      p_nomina: null,

      isLoading: false,
      isLoadingPage: false,

      documentos_relacionados: [],
      trabajador: null,

      empresa: null,

      successModal: false,
      warningModal: false,
      nanoid: undefined,
      error: "",

      showCancelJornada: false,
      showCancelDoc: false,
      showCancelCuadre: false,

      item: {},

      datos_trabajador: [],

      totalsColumns: [
        {
          title: "Concepto",
          field: "concepto",
          colStyle: {
            "text-align": "left",
          },
        },
        {
          title: "Horas Normales",
          field: "monto_horas_normales",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Horas Extras",
          field: "monto_horas_extras",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Destajo",
          field: "subtotal_actividad_variable",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Subtotal",
          field: "subtotal",
          colStyle: {
            "text-align": "right",
          },
        },
      ],
      encuadreColumns: [
        {
          title: "Concepto",
          field: "concepto",
          colStyle: {
            "text-align": "left",
          },
        },
        {
          title: "Horas Normales",
          colspan: 2,
          field: "monto_horas_normales_",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "",
          colspan: 0,
          field: "monto_horas_normales",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Horas Extras",
          colspan: 2,
          field: "monto_horas_extras_",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "",
          colspan: 0,
          field: "monto_horas_extras",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Destajo",
          colspan: 2,
          field: "subtotal_actividad_variable_",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "",
          colspan: 0,
          field: "subtotal_actividad_variable",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "Subtotal",
          colspan: 2,
          field: "subtotal_",
          colStyle: {
            "text-align": "right",
          },
        },
        {
          title: "",
          colspan: 0,
          field: "subtotal",
          colStyle: {
            "text-align": "right",
          },
        },
      ],
    };
  },
  created() {
    this.$store
      .dispatch("customHTTP", {
        schema: "configuracion",
        filter: {
          where: [
            {
              field: "payload->parametro",
              operator: "=",
              value: "analisis_nomina",
            },
          ],
        },
      })
      .then((config) => {
        if (config.data.length > 0) {
          this.datos_trabajador =
            config.data[0].payload.valor.modulo_detalle.datos_trabajador;
        }
      });
    this.getData();
  },
  computed: {
    _loadingModal: {
      get() {
        return !!this.loadingModal;
      },
      set(val) {
        this.loadingModal = val || "";
      },
    },
    periodo() {
      const { periodo_final, periodo_inicial } = this.folio
        ? this.item?.payload?.encabezado ?? {}
        : {
            periodo_inicial: this.p_periodo_inicial,
            periodo_final: this.p_periodo_final,
          };
      if (periodo_final && periodo_inicial) {
        return `${moment(periodo_inicial).format("DD/MM/YYYY")} al ${moment(
          periodo_final
        ).format("DD/MM/YYYY")}`;
      }
      return "";
    },
    totales() {
      const encabezado = this.item?.payload?.encabezado;
      return [
        ...encabezado?.dias.map((m) => {
          return {
            concepto: moment(m.fecha).format("DD/MM/YYYY"),
            monto_horas_normales: 0,
            monto_horas_extras: 0,
            subtotal_actividad_variable: 0,
            subtotal: 0,
            ...m,
          };
        }),
        { concepto: "Bonos", subtotal: encabezado?.totales?.bono ?? 0 },
        {
          concepto: "Caja de ahorro",
          subtotal: encabezado?.totales?.caja_de_ahorro ?? 0,
        },
        {
          concepto: "Préstamos",
          subtotal: encabezado?.totales?.prestamos ?? 0,
        },
        { concepto: "IMSS", subtotal: -(encabezado?.totales?.imss ?? 0) },
        {
          concepto: "Infonavit",
          subtotal: -(encabezado?.totales?.infonavit ?? 0),
        },
        { concepto: "Total", subtotal: encabezado?.totales?.sueldo_neto ?? 0 },
      ];
    },
    cuadre_fiscal() {
      const encabezado = this.p_nomina?.payload?.encabezado;
      const conceptosKey = [
        ...new Set([
          "horas_normales",
          "horas_extras",
          ...[
            ...Object.keys(encabezado?.fiscal?.conceptos ?? {}),
            ...Object.keys(encabezado?.no_fiscal?.conceptos ?? {}),
          ].sort((a, b) => a.localeCompare(b)),
        ]),
      ];

      const getTotalData = (key) => {
        return {
          monto_horas_extras: encabezado.fiscal?.totales?.[key] ?? 0,
          subtotal_actividad_variable:
            encabezado.no_fiscal?.totales?.[key] ?? 0,
          subtotal:
            (encabezado.fiscal?.totales?.[key] ?? 0) +
            (encabezado.no_fiscal?.totales?.[key] ?? 0),
        };
      };
      const dias_fiscal = encabezado.fiscal.dias.map((m) => ({
        ...m,
        valor: Number(moment(m.fecha).format("YYYYMMDD")),
      }));
      const dias_no_fiscal = encabezado.no_fiscal.dias.map((m) => ({
        ...m,
        valor: Number(moment(m.fecha).format("YYYYMMDD")),
      }));
      const dias = [];
      while (dias_fiscal.length > 0 && dias_no_fiscal.length > 0) {
        const dia_fiscal = dias_fiscal[0];
        const dia_no_fiscal = dias_no_fiscal[0];
        const dif = dia_fiscal.valor - dia_no_fiscal.valor;
        if (dif === 0) {
          dias.push({
            fecha: dia_no_fiscal.fecha,
            fiscal: dia_fiscal,
            no_fiscal: dia_no_fiscal,
          });
          dias_fiscal.shift();
          dias_no_fiscal.shift();
        }
        if (dif < 0) {
          dias.push({
            fecha: dia_no_fiscal.fecha,
            fiscal: {
              fecha: dia_no_fiscal.fecha,
              subtotal: 0,
              incidencias: "",
              monto_horas_normales: 0,
              cantidad_horas_normales: 0,
              subtotal_actividad_variable: 0,
            },
            no_fiscal: dia_no_fiscal,
          });
          dias_no_fiscal.shift();
        }
        if (dif > 0) {
          dias.push({
            fecha: dia_fiscal.fecha,
            no_fiscal: {
              fecha: dia_fiscal.fecha,
              subtotal: 0,
              incidencias: "",
              monto_horas_normales: 0,
              cantidad_horas_normales: 0,
              subtotal_actividad_variable: 0,
            },
            fiscal: dia_fiscal,
          });
          dias_fiscal.shift();
        }
      }
      return [
        {
          concepto: "",
          monto_horas_normales_: "Fiscal",
          monto_horas_normales: "No Fiscal",
          monto_horas_extras_: "Fiscal",
          monto_horas_extras: "No Fiscal",
          subtotal_actividad_variable_: "Fiscal",
          subtotal_actividad_variable: "No Fiscal",
          subtotal_: "Fiscal",
          subtotal: "No Fiscal",
        },

        ...dias.map((m) => {
          return {
            concepto: moment(m.fecha).format("DD/MM/YYYY"),
            monto_horas_normales_: `${this.$formatter(
              m.fiscal?.monto_horas_normales ?? 0
            )}`,
            monto_horas_normales: `${this.$formatter(
              m.no_fiscal?.monto_horas_normales ?? 0
            )}`,
            monto_horas_extras_: `${this.$formatter(
              m.fiscal?.monto_horas_extras ?? 0,
              1
            )}`,
            monto_horas_extras: `${this.$formatter(
              m.no_fiscal?.monto_horas_extras ?? 0,
              1
            )}`,
            subtotal_actividad_variable_: `${this.$formatter(
              m.fiscal?.subtotal_actividad_variable ?? 0,
              1
            )}`,
            subtotal_actividad_variable: `${this.$formatter(
              m.no_fiscal?.subtotal_actividad_variable ?? 0,
              1
            )}`,
            subtotal_: `${this.$formatter(m.fiscal?.subtotal ?? 0, 1)}`,
            subtotal: `${this.$formatter(m.no_fiscal?.subtotal ?? 0, 1)}`,
            ...m,
          };
        }),
        {
          concepto: " ",
          monto_horas_normales: " ",
          monto_horas_extras: "Fiscal",
          subtotal_actividad_variable: "No Fiscal",
          subtotal: "Subtotal",
          rowStyle: {
            borderTop: "2px solid #321fdb",
          },
        },

        ...conceptosKey.map((key) => {
          return {
            concepto: key
              .split("_")
              .map((m) => m.toCapitalize())
              .join(" "),
            monto_horas_normales: ` `,
            monto_horas_extras: `${this.$formatter(
              encabezado?.fiscal?.conceptos?.[key] ?? 0,
              1
            )}`,
            subtotal_actividad_variable: `${this.$formatter(
              encabezado?.no_fiscal?.conceptos?.[key] ?? 0,
              1
            )}`,
            subtotal: `${this.$formatter(
              (encabezado?.fiscal?.conceptos?.[key] ?? 0) +
                (encabezado?.no_fiscal?.conceptos?.[key] ?? 0),
              1
            )}`,
          };
        }),

        {
          concepto: "Total",
          ...getTotalData("sueldo"),
        },
      ];
    },
    documentos_relacionados_() {
      return this.allDocumentosRelacionados(this.documentos_relacionados);
    },

    ubicaciones_() {
      return this.$store.state.rootLocations?.map((m) => m.value);
    },
  },
  methods: {
    cancelarDoc() {
      this.showCancelDoc = false;
      this.loadingModal = "Cancelando...";
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "calculos_administrativos",
          folio: this.folio,
          serie: "",
        })
        .then((res) => {
          console.log(res);
          debugger;

          this.$router.push({
            name: "VerCalculoAdministrativoNomina",
            params: {
              periodo_inicial: this.p_periodo_inicial,
              periodo_final: this.p_periodo_final,
              empresa_id: this.p_empresa_id,
              trabajador_id: this.p_trabajador_id,
            },
          });
          this.folio = null;
          this.getData(true);
        })
        .catch((rej) => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          this.isLoadingPage = false;
          return;
        })

        .finally(() => {
          this.isLoading = false;
          this.isLoadingPage = false;
          this.loadingModal = "";
        });
    },
    cancelarCuadre() {
      this.showCancelCuadre = false;

      this.loadingModal = "Cancelando...";
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "nomina",
          folio: this.p_nomina.folio,
          serie: "",
        })
        .then((res) => {
          console.log(res);
          this.p_nomina = null;
          this.getData(true);
        })
        .catch((rej) => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          this.isLoadingPage = false;
          return;
        })

        .finally(() => {
          this.isLoading = false;
          this.isLoadingPage = false;
          this.loadingModal = "";
        });
    },
    cancelarJornadas() {
      const jornadas = this.getDocumentosRelacionados(`jornadas`).children;

      this.showCancelJornada = false;
      this.isLoading = false;

      this.loadingModal = "Cancelando...";
      this.$store
        .dispatch("customDocumentoCancelHTTP", jornadas)
        .then(() => {
          this.getData(false);
        })
        .catch((rej) => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })

        .finally(() => {
          this.isLoading = false;
          this.loadingModal = "";
        });
    },
    getData(flag = true) {
      debugger
      this.isLoadingPage = flag;
      this.isLoading = flag;

      // ubi.push(ubicacionTemplateNoRaiz);
      if (this.folio) {
        this.$store
          .dispatch("customDocumentoHTTP", {
            schema: "calculos_administrativos",
            filter: {
              wherein: [
                {
                  field: "payload->encabezado->ubicacion_raiz_id",
                  value: this.ubicaciones_,
                },
              ],
              where: [
                {
                  field: "folio",
                  value: this.folio,
                  operator: "=",
                },

                {
                  field: "doc_calculos_administrativos.estado",
                  operator: "!=",
                  value: "cancelado",
                },
              ],
            },
            ["with-storage"]: ["trabajador", "empresa"],
          })
          .then((item) => {
            this.item = item.data[0];
            console.log(JSON.stringify(this.item, null, 2));

            this.documentos_relacionados =
              this.getDocumentosRelacionadosBySchemas(
                this.item.payload.encabezado
              );

            this.p_empresa_id = this.item.payload?.encabezado?.empresa_id;
            this.p_trabajador_id = this.item.payload?.encabezado?.trabajador_id;
            this.p_periodo_inicial =
              this.item.payload?.encabezado?.periodo_inicial;
            this.p_periodo_final = this.item.payload?.encabezado?.periodo_final;

            this.p_trabajador =
              this.item.payload.encabezado._relaciones.trabajador;
            this.trabajador =
              this.item.payload.encabezado._relaciones.trabajador.payload.nombre;
            this.empresa =
              this.item.payload.encabezado._relaciones.empresa.payload.nombre;
            console.log(
              {
                field: "payload->encabezado->empresa_id",
                value: this.p_empresa_id,
                operator: "=",
              },
              {
                field: "payload->encabezado->periodo_inicial",
                value: this.p_periodo_inicial,
                operator: "=",
              },
              {
                field: "payload->encabezado->periodo_final",
                value: this.p_periodo_final,
                operator: "=",
              },
              {
                field: "payload->encabezado->trabajador_id",
                value: this.p_trabajador_id,
                operator: "=",
              }
            );
            return this.$store.dispatch("customDocumentoHTTP", {
              schema: "nomina",
              filter: {
                // wherein: [
                //   {
                //     field: "payload->encabezado->ubicacion_raiz_id",
                //     value: this.ubicaciones_,
                //   },
                // ],
                where: [
                  {
                    field: "payload->encabezado->empresa_id",
                    value: this.p_empresa_id,
                    operator: "=",
                  },
                  {
                    field: "payload->encabezado->periodo_inicial",
                    value: this.p_periodo_inicial,
                    operator: "=",
                  },
                  {
                    field: "payload->encabezado->periodo_final",
                    value: this.p_periodo_final,
                    operator: "=",
                  },
                  {
                    field: "payload->encabezado->trabajador_id",
                    value: this.p_trabajador_id,
                    operator: "=",
                  },

                  {
                    field: "payload->encabezado->calculos_administrativos",
                    value: this.folio,
                    operator: "=",
                  },

                  {
                    field: "doc_nomina.estado",
                    operator: "!=",
                    value: "cancelado",
                  },
                ],
              },
              // ["with-storage"]: ["*"],
            });
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.length > 0) {
              this.p_nomina = res.data[0];
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.isLoadingPage = false;
          });
      } else {
        Promise.all([
          this.$store.dispatch("actMethod", {
            url: "complementos_salario:estimado_nomina",
            fecha_inicial: this.p_periodo_inicial,
            fecha_final: this.p_periodo_final,
            empresa_id: this.p_empresa_id,
            trabajador_id: this.p_trabajador_id,
          }),
          this.$store.dispatch("customHTTP", {
            schema: "trabajadores",
            filter: {
              where: [
                {
                  field: "id",
                  operator: "=",
                  value: this.p_trabajador_id,
                },
                {
                  field: "payload->ubicaciones",
                  operator: "regexp",
                  value: `[[:<:]](${this.ubicaciones_.join("|")})[[:>:]]`,
                },
              ],
            },
          }),
          this.$store.dispatch("customHTTP", {
            schema: "empresas",

            filter: {
              where: [
                {
                  field: "id",
                  operator: "=",
                  value: this.p_empresa_id,
                },
              ],
            },
          }),
        ])
          .then(([item, trabajadores, empresas]) => {
            this.item = item.data[0];
            console.log(JSON.stringify(this.item, null, 2));

            this.documentos_relacionados =
              this.getDocumentosRelacionadosBySchemas(
                this.item.payload.encabezado
              );

            this.p_trabajador = trabajadores.data[0];
            this.trabajador = trabajadores.data[0].payload.nombre;
            this.empresa = empresas.data[0].payload.nombre;
          })
          .finally(() => {
            this.isLoading = false;

            this.isLoadingPage = false;
          });
      }
    },
    getDocumentosRelacionadosBySchemas(encabezado) {
      const docu = [];
      const {
        labores,
        prestaciones,

        bonos,
        bonos_aplicados,

        caja_de_ahorro,
        caja_de_ahorro_aplicadas,

        prestamos,
        prestamos_aplicados,

        jornadas,
        asistencias,
      } = encabezado;

      Object.entries({
        labores,
        prestaciones,

        bonos,
        bonos_aplicados,

        caja_de_ahorro,
        caja_de_ahorro_aplicadas,

        prestamos,
        prestamos_aplicados,

        jornadas,
        asistencias,
      }).map(([key, value]) => {
        if (value) {
          docu.push(
            ...value.map((m) => ({
              schema: key,
              ...m,
            }))
          );
        }
      });
      return docu;
    },
    getDocumentosRelacionados(schema) {
      const doc = this.documentos_relacionados_.find(
        (f) => f.schema === schema
      );
      return doc;
    },
    getLengthDocumentosRelacionados(schema) {
      const doc = this.getDocumentosRelacionados(schema);
      return doc.children.length > 0;
    },
    calcularJornadas() {
      //this.isLoading = true;
      const payloadCalcularPagosDias = {
        fecha_inicial: this.p_periodo_inicial,
        fecha_final: this.p_periodo_final,
        trabajador_id: Number(this.p_trabajador_id),
        empresa_id: Number(this.p_empresa_id),
      };

      this.$store
        .dispatch("httpAny", {
          endpoint: "asistencias_analisis:registrar_jornadas",
          body: payloadCalcularPagosDias,
        })
        .then((response) => {
          this.isLoading = false;
          this.isLoadingPage = false;
          console.log(response);
          this.getData(false);
          debugger;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.isLoadingPage = false;
          this.warningModal = true;
          this.error = error;
          debugger;

          // display error
        });
    },
    calcularPagoDias() {
      this.isLoading = true;
      const payloadCalcularPagosDias = {
        fecha_inicial: this.p_periodo_inicial,
        fecha_final: this.p_periodo_final,
        trabajador_id: this.p_trabajador_id,
        empresa_id: this.p_empresa_id,
      };
      debugger;
      this.$store
        .dispatch("httpAny", {
          endpoint: "complementos_salario:registrar_complementos_salario",
          body: payloadCalcularPagosDias,
        })
        .then((response) => {
          this.isLoading = false;
          this.isLoadingPage = false;
          console.log(response);
          debugger;
        })
        .catch((error) => {
          this.warningModal = true;
          this.error = error;
          console.log(error);
          this.isLoading = false;
          this.isLoadingPage = false;

          // display error
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.inventario-panel-row {
  margin-bottom: 10px;
  h4.inventario-panel-subtitle {
    width: 100%;
  }
  section {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
  }
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.dotContainer {
  padding: 12.5px;
  border: 4px dashed #cbcbcb;
  .flex-1 {
    flex: 1;
  }
}
.borderRadius15 {
  border-radius: 15px;
}
.borderBottom {
  border-bottom: 2px solid #282828;
  padding-bottom: 9px;
  margin-bottom: 18px;
}
.gap-2 {
  gap: 2rem;
}
</style>
